import { Controller } from "@hotwired/stimulus"
// import { useClickOutside, useIntersection, useTransition } from 'stimulus-use'
// import { useTransition } from "stimulus-use"
// import { IntersectionController } from 'stimulus-use'
// import { useTransition } from 'stimulus-use/dist/use-transition'

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends Controller {
  static targets = ["sidebar", "backdrop", "closeButton", "toggleArrow", "collapseIcon", "expandIcon", "panelIcon"]

  connect() {
    console.log("connect1")
  }

  toggle() {
    console.log("toggle1")

    // toggle sidebar visibility
    if (this.hasSidebarTarget) {
      // Sprawdź czy to translate sidebar (lewy layout) czy hidden sidebar (mail)
      const usesTranslate = this.sidebarTarget.classList.contains("-translate-x-full") ||
                            this.sidebarTarget.classList.contains("translate-x-0")

      if (usesTranslate) {
        this.sidebarTarget.classList.toggle("-translate-x-full")
        this.sidebarTarget.classList.toggle("translate-x-0")
      } else {
        this.sidebarTarget.classList.toggle("hidden")
      }
    }

    // toggle backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle("hidden")
    }

    // toggle close button
    if (this.hasCloseButtonTarget) {
      this.closeButtonTarget.classList.toggle("hidden")
    }

    // obracanie strzałki
    if (this.hasToggleArrowTarget) {
      this.toggleArrowTarget.classList.toggle("rotate-180")
      this.toggleArrowTarget.classList.toggle("rotate-0")
    }
    if (this.hasCollapseIconTarget && this.hasExpandIconTarget) {
      this.collapseIconTarget.classList.toggle("hidden")
      this.expandIconTarget.classList.toggle("hidden")
    }

    // obracanie ikony panelu i zmiana title
    if (this.hasPanelIconTarget) {
      const isHidden = this.sidebarTarget.classList.contains("hidden") ||
                       this.sidebarTarget.classList.contains("-translate-x-full")

      this.panelIconTargets.forEach(icon => {
        icon.classList.toggle("scale-x-[-1]", !isHidden)
        const button = icon.closest("button")
        if (button) button.title = button.dataset[isHidden ? "titleOpen" : "titleClose"] || ""
      })
    }

    // zapamiętaj stan sidebara w ustawieniach usera
    if (this.hasSidebarTarget && this.sidebarTarget.dataset.sidebarSettingKey) {
      const isVisible = !this.sidebarTarget.classList.contains("hidden") &&
                        !this.sidebarTarget.classList.contains("-translate-x-full")
      IntumJs.setField(this.sidebarTarget.dataset.sidebarSettingKey, isVisible, { check: false })
    }
  }

  hide(_event) {
    // console.log('hide1', this.element, event.target)
    // console.log('hide1', event)
    this.leave()
  }

  disconnect() {
  }

  signOut(event) {
    if (this._isTurboNativeApp) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.TurboNativeBridge.postMessage("signOut")
    }
  }

  get _isTurboNativeApp() {
    return navigator.userAgent.indexOf("Turbo Native") !== -1
  }
}
